<template>
  <div class="header">
    <div class="header-nofixed">
      <!-- <div class="header-images"><img src="../assets/common/header.png" alt=""></div> -->
      <div class="header-nav">
        <div class="header-nav-container">
          <div class="header-nav-left">
            <i @click="goHYIndex">返回宏云服务平台</i>
            <span>宏云课堂欢迎您！</span>
            <div class="user"><img src="../assets/icon/user.svg" alt="">用户登录/注册</div>
          </div>
          <ul class="header-nav-right">
            <li><a href="http://hongyun.zhonghongwang.com/">宏云首页</a></li>
            <li><a href="http://jinfu.hongyun.zhonghongwang.com/">宏云金服</a></li>
            <li><a href="http://hongyun.zhonghongwang.com/views/credit/creditSearch.html">宏云信用</a></li>
            <!-- <li><a href="http://mall.hongyun.zhonghongwang.com/zsemall-js_frontend/">宏云商城</a></li> -->
            <li><a href="http://index.hongyun.zhonghongwang.com/">宏云指数</a></li>
            <li><a href="http://hongyun.zhonghongwang.com/views/information.html">宏云资讯</a></li>
            <li><a href="http://tags.hongyun.zhonghongwang.com/">宏云课堂</a></li>
            <li><a href="http://hongyun.zhonghongwang.com/views/anli/anli.html">惠企案例</a></li>
          </ul>
        </div>
      </div>
      <div class="header-server">
        <div class="header-server-logo" @click="goIndex">
          <!-- <img src="../assets/common/logo2.png" alt=""> -->
          <span>宏云课堂</span></div>
        <div class="header-server-search">
          <div class="header-server-input"><input type="text" placeholder="国有企业招标采购"></div>
          <div class="header-server-btn"><img src="../assets/icon/search.svg" alt=""><span>搜索</span></div>
        </div>
      </div>
    </div>
    <div class="header-fixed" v-show="fixedflag">
      <div class="header-fixed-container">
        <div class="header-fixed-logo">
          <!-- <img src="../assets/common/logo1.png" alt=""> -->
          <span>宏云课堂</span>
        </div>
        <ul class="header-fixed-nav">
          <li><a href="javascript:;" @click="goHref('/')">首页</a></li>
          <li><a href="javascript:;" @click="goHref('/classlist')">全部课程</a></li>
          <li><a href="javascript:;" @click="goHref('/company')">入驻机构</a></li>
          <li><a href="javascript:;" @click="goHref('/teacher')">合作讲师</a></li>
          <li><a href="javascript:;" @click="goHref('/come')">加盟入驻</a></li>
          <li><a href="javascript:;" @click="goHref('/examlist')">考试入口</a></li>
          <li><a href="javascript:;" @click="goHref('/book')">证书查询</a></li>
        </ul>
        <div class="header-fixed-search">
          <input type="text" placeholder="请输入搜索关键字"><img src="../assets/icon/fixedsearch.svg" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      fixedflag: false
    }
  },
  mounted() {
    this.handleScroll()
    window.addEventListener('scroll', this.handleScroll) 
  },
  methods: {
    goHref(url) {
      this.$router.push(url)
    },
    handleScroll() {
      var scrollTop = window.pageXOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 230) {
        this.fixedflag = true
      } else {
        this.fixedflag = false
      }
    },
    goIndex() {
      this.$router.push('/')
    },
    goHYIndex() {
      window.open('http://hongyun.zhonghongwang.com/')
    }
  }
};
</script>

<style lang="less" scoped>
.header {
  &-images {
    background: #f6f8fb;
    text-align: center;
    img {
      width: 1920px;
      height: 50px;
    }
  }
  &-nav {
    background: #fff;
    height: 32px;
    border-bottom: 1px solid #F1F1F1;
    &-container {
      width: 1300px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    &-left {
      display: flex;
      align-items: center;
      height: 32px;
      i{
        font-style: normal;
        font-size: 10px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #666666;
line-height: 14px;
background: #F4F5F9;
border-radius: 4px 4px 4px 0px;
padding: 3px 6px;
margin-right: 20px;
cursor: pointer;
      }

      span {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        line-height: 32px;
      }
      .user {
        font-size: 12px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ff7e20;
        line-height: 22px;
        margin-left: 25px;
        display: flex;
        align-items: center;
        img {
          width: 14px;
          height: 14px;
          margin-right: 1px;
        }
      }
    }
    &-right {
      li {
        display: inline-block;
        margin-left: 40px;
        a {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #000000;
          line-height: 22px;
        }
      }
    }
  }
  &-server {
    width: 1300px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 48px;
    padding-bottom: 40px;
    &-logo {
      height: 29px;
      display: flex;
      align-items: flex-end;
      cursor: pointer;
      img {
        width: auto;
        height: 29px;
        margin-right: 29px;
      }
      span {
        font-size: 36px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #b6141a;
        line-height: 28px;
      }
    }
    &-search {
      display: flex;
      align-items: center;
    }
    &-input {
      width: 318px;
      height: 40px;
      background: #ffffff;
      border-radius: 2px 0px 0px 2px;
      border: 2px solid #bd1920;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      input {
        width: 300px;
        margin-left: 10px;
      }
    }
    &-btn {
      width: 81px;
      height: 40px;
      background: linear-gradient(90deg, #dc2d38 0%, #b6141a 100%);
      line-height: 40px;
      border-radius: 0px 2px 2px 0px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 17px;
        height: 16px;
        margin-right: 12px;
      }
      span {
        font-size: 12px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
      }
    }
  }
  &-fixed {
    height: 80px;
    background: #B6141A;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    z-index: 11;
    &-container {
      width: 1300px;
      height: 80px;
      margin: 0 auto;
      display: flex;
      align-items: center;
    }
    &-logo {
      flex: 1;
      cursor: pointer;
      img {
        width: 211px;
        height: 29px;  
      }
      span {
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 28px;  
        margin-left: 10px;     
      }
    }
    &-nav {
      display: flex;
      li {
        margin-left: 24px;
        a {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 22px;
        }
      }
    }
    &-search {
      width: 160px;
      height: 32px;
      background: #FFFFFF;
      border-radius: 2px;
      border: 1px solid #D9D9D9;
      display: flex;
      align-items: center;  
      justify-content: space-between;
      margin-left: 68px;
      padding-left: 12px;
      padding-right: 9px;
      box-sizing: border-box;
      input {
        width: 8em;
      }
      img {
        width: 14px;
        height: 14px;
      }  
    }
  }
}
</style>